<template>
  <v-layout wrap>
    <v-flex md3 xs12>
       <SellerDashboard></SellerDashboard>
    </v-flex>
    <v-flex md9 xs12>
    <v-card style="margin-left:20px; margin-right:20px;margin-top:20px;">
      <v-row>
        <v-col md="3">
        </v-col>
        <v-col md="6">
          <v-card-title>Add Images</v-card-title>
          <div
            id="my-strictly-unique-vue-upload-multiple-image"
            style="display: flex; justify-content: center;"
          >
            <vue-upload-multiple-image
              @upload-success="uploadImageSuccess"
              @before-remove="beforeRemove"
              @edit-image="editImage"
              @limit-exceeded="imageLimit"
              :data-images="images"
              :maxImage="6"
            ></vue-upload-multiple-image>
          </div>
        </v-col>
      </v-row>
    </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";
import SellerDashboard from "@/components/common/SellerDashboard";
import axios from "axios";

export default {
  props: ["id"],
  components: {
    VueUploadMultipleImage,
    SellerDashboard
  },
  data() {
    return {
      msg: null,
      // Image Upload Variables

      dataImages: null,
      deleteId: null,
      doc2sts: 0,
      images: [],

      userAvatar: undefined,

      uploadheader: {
        to: localStorage.getItem("token")
      },
      uploadFormData: {
        branchid: null
      }
    };
  },

  methods: {
    onSelectImage(event) {
      console.log(event.id);
      this.deleteId = event.id;
    },
    imguplderr(resp) {
      console.log(resp);
    },
    imageLimit() {
      this.msg = "Upload Limit exceeded Please Select max 4 images";
      this.$dlg.alert(
        this.msg,
        () => {
          // this.$router.push("/Dashboard");
        },
        { messageType: "error" }
      );
    },
      uploadImageSuccess(formData, index, fileList) {
      console.log("data", formData, index, fileList);
      formData.append('productid',this.id)
      axios({
         method: "post",
        url: "/Product/UploadImagesingle/",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token")
        }
      })
           .then(response => {
                if (response.data.status == true) {
                  this.msg = "Upload sucess";
                  this.$dlg.alert(this.msg,() => {  },
                    { messageType: "success" }
                  );
                } else {
                  this.msg = "Upload max 4 images";
                  this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
                }
              })
              .catch(e => {
                this.msg = "Image Upload Not Success";
                this.$dlg.alert(
                  this.msg,
                  () => {
                    // this.$router.push("/pending");
                  },
                  { messageType: "error" }
                );
              });
   },

  }
};
</script>